import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

// When env vars are absent, the app falls back to local demo mode (see lib/db.js).
export const isConfigured = Boolean(url && key);
if (!isConfigured && import.meta.env.PROD) {
  console.warn('KAPSTAT: VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are not set — running in demo mode, no data is recorded.');
}
export const supabase = isConfigured
  ? createClient(url, key, { auth: { persistSession: true, autoRefreshToken: true } })
  : null;
